import { UpdateInventoryRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';
import _ from 'lodash';

class UpdateInventoryService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new UpdateInventoryRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	findGroupedInventoryLog(filter) {
		var url = this.routeService.findGroupedInventoryLog(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	updateInventoryForProduct = (productId, sourceOfChange) => {
		var url = this.routeService.updateInventoryForProduct(productId, sourceOfChange);
		return this.apiClient.put(url, productId);
	};

	updateInventoryForChannel = (channelId, sourceOfChange, isMliReset) => {
		var url = this.routeService.updateInventoryForChannel(channelId, sourceOfChange, isMliReset);
		return this.apiClient.put(url, channelId);
	};

	updateInventory(sourceOfChange) {
		var url = this.routeService.updateInventory(sourceOfChange);
		return this.apiClient.get(url);
	}
}

export default UpdateInventoryService;
